import React, { useEffect } from "react";
import { FaCarRear, FaLightbulb, FaSliders } from "react-icons/fa6";
import { GrInstall } from "react-icons/gr";
import { Link } from "react-router-dom";
import AOS from "aos";
import "aos/dist/aos.css";
import ResponsiveButton from "../ResponsiveButton/ResponsiveButton";
import { trackEvent } from "../../utils/analytics";

const servicesData = [
  {
    key: "kuljetus",
    name: "Kuljetus ja peräkärry",
    anchor: "perakarryn-vuokraus",
    icon: FaCarRear,
    chip: "Kuljetus",
    description:
      "Kuljetuspalvelu sekä HIRVI 350 -kuomukärryn vuokraus kaluston ja tavaroiden kuljettamiseen.",
  },
  {
    key: "asennus",
    name: "Asennus ja opastus",
    anchor: "opastuspalvelu",
    icon: GrInstall,
    chip: "Käyttövalmis",
    description:
      "Toimitamme laitteet käyttövalmiiksi ja annamme selkeät käyttöohjeet paikan päällä.",
  },
  {
    key: "kokototeutus",
    name: "Koko illan tekniikka",
    anchor: "valojaanen",
    icon: FaLightbulb,
    chip: "Huoleton",
    description:
      "Äänentoiston ja valaistuksen tekninen toteutus tapahtuman tarpeiden mukaan.",
  },
  {
    key: "esiintyjatekniikka",
    name: "Tekniikka keikalle",
    anchor: "tekniikka-esiintyjille",
    icon: FaSliders,
    chip: "PA & valot",
    description:
      "PA, monitorointi, miksaus ja valot live-esiintymisiin ja ohjelmanumeroihin.",
  },
];

const Services = () => {
  useEffect(() => {
    AOS.init({ duration: 700, once: true });

    trackEvent("palvelut_osio_nakyi", {
      osio: "services",
      korttien_maara: servicesData.length,
    });
  }, []);

  return (
    <section
      className="
        relative overflow-hidden py-20
        bg-gradient-to-br from-white via-[#F3FFFC] to-[#E9FBF7]
        dark:from-[#050505] dark:via-[#08080A] dark:to-[#0D0D12]
      "
      aria-labelledby="services-heading"
    >
      <div className="mx-auto max-w-7xl px-4">
        <div
          className="
            rounded-[2rem] border border-[#DDE7E5] bg-white p-6 shadow-xl
            dark:border-darkborder dark:bg-[#111114]
            md:p-8
          "
        >
          {/* Otsikko ja intro */}
          <div className="mb-10 max-w-4xl">
            <span
              className="
                mb-4 inline-flex rounded-full border border-primary/40 bg-primary/10
                px-4 py-2 font-customFont1 text-sm font-extrabold uppercase
                tracking-[0.14em] !text-[#111827]
                dark:!text-white
              "
            >
              Miksi valita meidät?
            </span>

            <h2
              id="services-heading"
              data-aos="fade-up"
              className="
                font-customFont2 text-left text-3xl sm:text-3xl md:text-5xl lg:text-6xl xl:text-7xl font-bold leading-snug
                text-text
                dark:text-darktext
              "
            >
              Tekniikka tapahtumaan helposti
            </h2>

            <p
              data-aos="fade-up"
              className="
                mt-5 max-w-3xl font-customFont1 text-left text-lg font-normal
                leading-relaxed !text-[#374151]
                dark:!text-[#D1D5DB]
                xl:text-xl
              "
            >
              Spiderlegs Productions tarjoaa käytännölliset ratkaisut
              äänentoistoon, valotekniikkaan, kuljetukseen ja asennukseen.
              Tavoitteena on, että tapahtuman tekninen puoli toimii selkeästi,
              luotettavasti ja ilman turhaa säätöä.
            </p>
          </div>

          {/* Palvelukortit */}
          <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-4">
            {servicesData.map((service) => {
              const Icon = service.icon;

              return (
                <article
                  key={service.key}
                  data-aos="fade-up"
                  className="
                    group flex h-full flex-col rounded-3xl border border-[#DDE7E5]
                    bg-[#F8FAFC] p-5 text-left transition
                    hover:-translate-y-1 hover:border-primary hover:bg-[#F3FFFC] hover:shadow-lg
                    dark:border-darkborder dark:bg-darksurface
                    dark:hover:border-primary dark:hover:bg-darksurface2
                  "
                >
                  <div className="mb-5 flex items-start justify-between gap-3">
                    <div
                      className="
                        flex h-14 w-14 items-center justify-center rounded-2xl
                        border border-primary/30 bg-primary/10
                        text-primary
                      "
                    >
                      <Icon className="text-3xl" />
                    </div>

                    <span
                      className="
                        rounded-full border border-[#DDE7E5] bg-white px-3 py-1
                        font-customFont1 text-xs font-bold !text-[#111827]
                        dark:border-darkborder dark:bg-[#111114] dark:!text-white
                      "
                    >
                      {service.chip}
                    </span>
                  </div>

                  <h3
                    className="
                      font-customFont2 text-3xl font-normal leading-none
                      !text-[#111827]
                      dark:!text-white
                    "
                  >
                    {service.name}
                  </h3>

                  <p
                    className="
                      mt-4 flex-grow font-customFont1 text-base font-normal
                      leading-relaxed !text-[#4B5563]
                      dark:!text-[#D1D5DB]
                    "
                  >
                    {service.description}
                  </p>

                  <div className="mt-6">
                    <Link
                      to={`/palvelut#${service.anchor}`}
                      onClick={() =>
                        trackEvent("palvelu_klikattu", {
                          palvelu: service.key,
                          kohde: "palvelut_sivu",
                        })
                      }
                    >
                      <ResponsiveButton
                        variant="servicesreadmore"
                        className="w-full"
                      >
                        Lue lisää
                      </ResponsiveButton>
                    </Link>
                  </div>
                </article>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Services;